import { render, staticRenderFns } from "./PdfLayer.vue?vue&type=template&id=fa954754&scoped=true&"
import script from "./PdfLayer.vue?vue&type=script&lang=js&"
export * from "./PdfLayer.vue?vue&type=script&lang=js&"
import style0 from "./PdfLayer.vue?vue&type=style&index=0&id=fa954754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa954754",
  null
  
)

export default component.exports